module.exports = __webpack_public_path__ + "img/6.5fd9c6de.png";